<div class="ac-page c7-access-view c7-access-forgot-password">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <a class="ac-brand" href="javascript:void(0)" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center">
    <section class="ac-card ac-card--single" aria-labelledby="ac-title">
      <div class="ac-card__head">
        <h2 id="ac-title">{{ "form.ResetPassword" | translate }}</h2>
        <p class="ac-card__sub">{{ "authPages.forgotIntro" | translate }}</p>
      </div>

      <form [formGroup]="forgetPasswordForm" (ngSubmit)="sendEmailResetPassword()" novalidate class="ac-form">
        <div class="ac-field">
          <label for="ac-email">{{ "form.email" | translate }}</label>
          <input id="ac-email" type="email" formControlName="email" autocomplete="username" (input)="blurmsg()"
            [attr.aria-invalid]="(submitted || f['email'].touched) && f['email'].invalid ? 'true' : 'false'" />
          <span class="ac-error" *ngIf="(submitted || f['email'].touched) && f['email'].hasError('required')" aria-live="polite">{{ "login.form.email.error.required" | translate }}</span>
          <span class="ac-error" *ngIf="submitted && !f['email'].hasError('required') && f['email'].invalid" aria-live="polite">{{ "login.form.email.error.email" | translate }}</span>
        </div>

        <button class="ac-btn" type="submit">{{ "forgotPassword.form.send" | translate }}</button>
        <p class="ac-error ac-error--block" *ngIf="errormsg" role="alert">{{ errormsg | translate }}</p>
      </form>

      <hr class="ac-card__divider" />
      <p class="ac-card__alt"><a [routerLink]="['/login']">{{ "authPages.backToLogin" | translate }}</a></p>
    </section>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
